import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div>
            <h1>Kabir Tech Serv</h1>
            <p>@all rights reserved</p>
        </div>
        <div>
            <h5>Follow us</h5>
            <div>
                <a href="https://instagram.com/kabirkhandelwal">Instagram</a>
                <a href="https://www.linkedin.com/in/ayush-akshat-bb7544191">LinkedIn</a>
                <a href="https://github.com/">GitHub</a>
            </div>
        </div>
    </footer>
  )
}

export default Footer